var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"cart py-4",attrs:{"xl":"4","lg":"3","cols":"12"}},[_vm._v(" Cart "),_c('b-badge',[_vm._v(_vm._s(_vm.cart.length))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }